// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import XRegExp from 'xregexp'
import { coordsDMS } from 'helpers/regex'
import { getCardinal } from 'helpers/coordsConversion'

/**
 * converts defined DMS formats into the preferred DMS format
 * @param {String} val
 * @param {String} axis - latitude || longitude
 * @param {Boolean} preferWesternHemisphere - allows us to force W hemisphere for positive longitude values w/o cardinal given
 * @returns {string|null} - the formatted value or null if the value is not valid DMS for formatting
 */
const convertDMStoDMSPref = (val, axis, preferWesternHemisphere = false) => {
  const r = XRegExp.exec(val, coordsDMS)?.groups || null
  // regular expression does not catch
  // if prefix AND suffix are given
  if (!r || r.prefix && r.suffix) {
    return null
  }
  const d = parseInt(r.degrees).toString().padStart(2, '0')

  // pads the value so it has a leading zero if > 10
  const m = parseInt(r.minutes).toString().padStart(2, '0')

  let s = Math.round(parseFloat(r.seconds) * 1e2) / 1e2

  s = (
    // checks to see if the value is an int or has only one decimal place
    +s.toFixed(1) === s
      //  if so, then it just pads the left hand of the string for leading zeros if needed
      // making 2.3 -> 02.3
      // and
      // pads with a trailing zero if an int (from toFixed)
      // making 2 -> 02.0
      ? s.toFixed(1).padStart(4, '0')
      // if there are two decimals then we need to make sure to pad the
      // left hand side differently since there are more chars to consider.
      : s.toFixed(2).padStart(5, '0')
  )

  const c = getCardinal(r, axis, preferWesternHemisphere)

  // if the cardinal direction could not be determined from the value,
  // err this out as an invalid value.
  if (c === null) {
    return null
  }

  return `${d} ${m} ${s} ${c}`
}

export default convertDMStoDMSPref
